import React, { useState, useRef, useEffect } from "react";
import { useSectionInView } from "../assets/lib/hooks";
import { motion, useScroll, useTransform } from "framer-motion";
import { MdAssignmentInd, MdApartment, MdCalendarMonth, MdLocationPin, MdGroups2, MdLegendToggle, MdOutlineArrowDropDownCircle } from "react-icons/md";
import "react-toastify/dist/ReactToastify.css";
import "swiper/css";
import "swiper/css/effect-cards";
import "swiper/css/pagination";
import { useTypedSelector } from '../stateStore';
import { useTheme } from "../context/theme-context";

const AccordionItem = (props: any) => {
  const contentEl : any = useRef();
  const { id, handleToggle, active, project, theme } = props;
  const { designation, organization, clients, vendors, duration, location, teamSize, description, workDone, technologies } = project;

  return (
    <div className="rc-accordion-card">
      <div className="rc-accordion-header">
        <div className={`rc-accordion-toggle p-3 ${active === id ? 'active' : ''}`} onClick={() => handleToggle(id)}>
          <h5 className="rc-accordion-title">{organization} {clients.length > 0 ? " - " + clients.join(", ") : ""}</h5>
          <span className="rc-accordion-icon"><MdOutlineArrowDropDownCircle /></span>
        </div>
      </div>
      <div ref={contentEl} className={`rc-collapse ${active === id ? 'show' : ''}`} style={
        active === id
          ? { height: contentEl.current.scrollHeight }
          : { height: "0px" }
      }>
        <div className="rc-accordion-body">
          <div className="flex flex-col justify-between">
            <div style={{ color: (theme == "light") ? "black" : "white", textAlign: "center", marginBottom: "15px", display: "inline-flex", fontSize: "20px" }}>
              <div style={{ color: (theme == "light") ? "black" : "white", textAlign: "left", marginBottom: "15px", fontSize: "20px", wordBreak: "break-word", width: "50%" }}>
                <div style={{ color: (theme == "light") ? "black" : "white", textAlign: "center", marginBottom: "15px", display: "inline-flex", fontSize: "34px" }}>
                  <span style={{ fontFamily: "poppins-bold", fontSize: "34px", display: "inline-flex", textAlign: "justify", alignItems: "center" }}><MdApartment />&nbsp;</span>
                </div>
                {organization.length > 0 ? <div style={{ color: (theme == "light") ? "black" : "white", textAlign: "center", marginBottom: "15px", display: "inline-flex", fontSize: "34px" }}>
                  <span className="highlight-text" style={{ fontFamily: "poppins-bold", fontSize: "34px", display: "inline-flex", textAlign: "left", alignItems: "center" }}>{organization}</span>
                </div> : ""}
              </div>
              <div style={{ fontFamily: "poppins-regular", color: (theme == "light") ? "black" : "white", textAlign: "center", display: "grid", fontSize: "20px", wordBreak: "break-word", width: "50%" }}>
                {designation.length > 0 ? <div style={{ fontFamily: "poppins-regular", color: (theme == "light") ? "black" : "white", textAlign: "center", display: "inline-flex", fontSize: "20px" }}>
                  <span style={{ fontFamily: "poppins-regular", fontSize: "20px", display: "inline-flex", textAlign: "center", alignItems: "center" }}><MdAssignmentInd />&nbsp;</span>
                  <span style={{ fontFamily: "poppins-regular", fontSize: "14px", display: "inline-flex", textAlign: "left", alignItems: "center" }}>{designation}</span>
                </div> : ""}
                {duration.length > 0 ? <div style={{ fontFamily: "poppins-regular", color: (theme == "light") ? "black" : "white", textAlign: "center", display: "inline-flex", fontSize: "20px" }}>
                  <span style={{ fontFamily: "poppins-regular", fontSize: "20px", display: "inline-flex", textAlign: "center", alignItems: "center" }}><MdCalendarMonth />&nbsp;</span>
                  <span style={{ fontFamily: "poppins-regular", fontSize: "14px", display: "inline-flex", textAlign: "left", alignItems: "center" }}>{duration}</span>
                </div> : ""}
                {location.length > 0 ? <div style={{ fontFamily: "poppins-regular", color: (theme == "light") ? "black" : "white", textAlign: "center", display: "inline-flex", fontSize: "20px" }}>
                  <span style={{ fontFamily: "poppins-regular", fontSize: "20px", display: "inline-flex", textAlign: "center", alignItems: "center" }}><MdLocationPin />&nbsp;</span>
                  <span style={{ fontFamily: "poppins-regular", fontSize: "14px", display: "inline-flex", textAlign: "left", alignItems: "center" }}>{location}&nbsp;&nbsp;&nbsp;</span>
                </div> : ""}
                {teamSize.length > 0 ? <div style={{ fontFamily: "poppins-regular", color: (theme == "light") ? "black" : "white", textAlign: "center", marginBottom: "15px", display: "inline-flex", fontSize: "20px" }}>
                  <span style={{ fontFamily: "poppins-regular", fontSize: "20px", display: "inline-flex", textAlign: "center", alignItems: "center" }}><MdGroups2 />&nbsp;</span>
                  <span style={{ fontFamily: "poppins-regular", fontSize: "14px", display: "inline-flex", textAlign: "left", alignItems: "center" }}>{teamSize}</span>
                </div> : ""}
              </div>
            </div>
            {description.length > 0 ? <div style={{ fontFamily: "poppins-regular", color: (theme == "light") ? "black" : "white", textAlign: "left", marginBottom: "15px", fontSize: "14px" }}>
              <span className="highlight-text" style={{ fontFamily: "poppins-bold", fontSize: "14px" }}>About :&nbsp;</span>
              <span style={{ fontFamily: "poppins-regular", fontSize: "14px" }}>{description}</span>
            </div> : ""}
            {clients.length > 0 ? <div style={{ fontFamily: "poppins-regular", color: (theme == "light") ? "black" : "white", textAlign: "left", marginBottom: "15px", fontSize: "14px" }}>
              <span className="highlight-text" style={{ fontFamily: "poppins-bold", fontSize: "14px" }}>Client :&nbsp;</span>
              <span style={{ fontFamily: "poppins-regular", fontSize: "14px", margin: "4px" }}>{clients.join(" | ")}</span>
            </div> : ""}
            {vendors.length > 0 ? <div style={{ fontFamily: "poppins-regular", color: (theme == "light") ? "black" : "white", textAlign: "left", marginBottom: "15px", fontSize: "14px" }}>
              <span className="highlight-text" style={{ fontFamily: "poppins-bold", fontSize: "14px" }}>Vendor :&nbsp;</span>
              <span style={{ fontFamily: "poppins-regular", fontSize: "14px", margin: "4px" }}>{vendors.join(" | ")}</span>
            </div> : ""}
            {technologies.length > 0 ? <div style={{ fontFamily: "poppins-regular", color: (theme == "light") ? "black" : "white", textAlign: "left", marginBottom: "15px", fontSize: "14px" }}>
              <span className="highlight-text" style={{ fontFamily: "poppins-bold", fontSize: "14px" }}>Technologies :&nbsp;</span>
              <span style={{ fontFamily: "poppins-regular", fontSize: "14px", margin: "4px" }}>{technologies.join(" | ")}</span>
            </div> : ""}
            {workDone.length > 0 ? <div style={{ fontFamily: "poppins-regular", color: (theme == "light") ? "black" : "white", textAlign: "left", fontSize: "14px" }}>
              <span className="highlight-text" style={{ fontFamily: "poppins-bold", fontSize: "14px" }}>What I've Done</span>
              <span style={{ fontFamily: "poppins-regular", fontSize: "14px" }}> : </span>
              <span>
                <ol>
                  {workDone.map((work : any, index: number) => (
                    <li key={index} style={{ fontFamily: "poppins-regular", fontSize: "14px", margin: "4px", listStyleType: "disclosure-closed", listStylePosition: "inside", textIndent: "-1.1em", paddingLeft: "1em" }}>{work}</li>
                  ))}
                </ol>
              </span>
            </div> : ""}
          </div>
        </div>
      </div>
    </div>
  )
}

const ProjectSlider: React.FC = () => {

  const projectsStatus = useTypedSelector(state => state.Projects.loading)
  const projectsData = useTypedSelector(state => state.Projects.data)

  const { theme } = useTheme()
  const { ref } = useSectionInView("Projects");
  const animationReference = useRef<HTMLDivElement>(null);
  const { scrollYProgress } = useScroll({
    target: animationReference,
    offset: ["1 1", "1.3 1"],
  });
  const scaleProgess = useTransform(scrollYProgress, [0, 1], [0.8, 1]);
  const opacityProgess = useTransform(scrollYProgress, [0, 1], [0.6, 1]);

  const [active, setActive] = useState(null);

  useEffect(() => {
  }, [projectsStatus, projectsData]);

  const handleToggle = (index: any) => {
    if (active === index) {
      setActive(null);
    } else {
      setActive(index);
    }
  }

  return (
    <React.Fragment>
      <section
        className="relative tech-stack max-lg:p-8 "
        id="projects"
        ref={ref} >
        <div className="title-container flex flex-col justify-center items-center p-28 gap-6">
          <motion.div
            ref={animationReference}
            style={{
              scale: scaleProgess,
              opacity: opacityProgess,
            }} >
            <p className="font-black mb-6">
              <span className="text-[--orange]">&lt;</span>Projects
              <span className="text-[--orange]">/&gt;</span>
            </p>
            <h2>My Projects</h2>
          </motion.div>
        </div>
        <div className="card lg:pl-40 lg:pr-40">
          {projectsStatus ? "Loading" : 
            projectsData.map((project, index) => {
              return (
                <AccordionItem key={index} id={index} active={active} handleToggle={handleToggle} project={project} theme={theme}/>
              )
            })
          }
        </div>
        <div className="lg:pl-40 lg:pr-40 pb-28" style={{ textAlign: "center" }}>
          <p style={{ fontFamily: "poppins-bold", color: "black", textAlign: "center", fontSize: "12px" }}>&nbsp;</p>
          <p className="highlight-text" style={{ fontFamily: "poppins-regular", color: (theme == "light") ? "var(--orange)" : "var(--orange)", textAlign: "center", display: "inline-flex", fontSize: "16px" }}>
            <span style={{ fontFamily: "poppins-regular", fontSize: "20px", fontWeight: "bold", display: "inline-flex", textAlign: "justify", alignItems: "center" }}><MdLegendToggle />&nbsp;</span>
            <span style={{ fontFamily: "poppins-regular", fontSize: "14px", fontWeight: "bold", display: "inline-flex", textAlign: "justify", alignItems: "center" }}>Legend :&nbsp;</span>
          </p>
          <p style={{ fontFamily: "poppins-regular", color: (theme == "light") ? "black" : "white", textAlign: "center", display: "inline-flex", fontSize: "20px" }}>
            <span style={{ fontFamily: "poppins-regular", fontSize: "20px", display: "inline-flex", textAlign: "justify", alignItems: "center" }}><MdApartment />&nbsp;</span>
            <span style={{ fontFamily: "poppins-regular", fontSize: "14px", display: "inline-flex", textAlign: "justify", alignItems: "center" }}>Organization&nbsp;,&nbsp;</span>
          </p>
          <p style={{ fontFamily: "poppins-regular", color: (theme == "light") ? "black" : "white", textAlign: "center", display: "inline-flex", fontSize: "20px" }}>
            <span style={{ fontFamily: "poppins-regular", fontSize: "20px", display: "inline-flex", textAlign: "justify", alignItems: "center" }}><MdAssignmentInd />&nbsp;</span>
            <span style={{ fontFamily: "poppins-regular", fontSize: "14px", display: "inline-flex", textAlign: "justify", alignItems: "center" }}>Designation&nbsp;,&nbsp;</span>
          </p>
          <p style={{ fontFamily: "poppins-regular", color: (theme == "light") ? "black" : "white", textAlign: "center", display: "inline-flex", fontSize: "20px" }}>
            <span style={{ fontFamily: "poppins-regular", fontSize: "20px", display: "inline-flex", textAlign: "justify", alignItems: "center" }}><MdCalendarMonth />&nbsp;</span>
            <span style={{ fontFamily: "poppins-regular", fontSize: "14px", display: "inline-flex", textAlign: "justify", alignItems: "center" }}>Duration&nbsp;,&nbsp;</span>
          </p>
          <p style={{ fontFamily: "poppins-regular", color: (theme == "light") ? "black" : "white", textAlign: "center", display: "inline-flex", fontSize: "20px" }}>
            <span style={{ fontFamily: "poppins-regular", fontSize: "20px", display: "inline-flex", textAlign: "justify", alignItems: "center" }}><MdLocationPin />&nbsp;</span>
            <span style={{ fontFamily: "poppins-regular", fontSize: "14px", display: "inline-flex", textAlign: "justify", alignItems: "center" }}>Location&nbsp;,&nbsp;</span>
          </p>
          <p style={{ fontFamily: "poppins-regular", color: (theme == "light") ? "black" : "white", textAlign: "center", marginBottom: "15px", display: "inline-flex", fontSize: "20px" }}>
            <span style={{ fontFamily: "poppins-regular", fontSize: "20px", display: "inline-flex", textAlign: "justify", alignItems: "center" }}><MdGroups2 />&nbsp;</span>
            <span style={{ fontFamily: "poppins-regular", fontSize: "14px", display: "inline-flex", textAlign: "justify", alignItems: "center" }}>Team Size&nbsp;&nbsp;</span>
          </p>
        </div>
      </section>
    </React.Fragment>
  );
}

export default ProjectSlider;
